import {StyleSheet} from 'react-native';

import {black, ravenBlack} from '/theme/color/on.color';
import {graniteGray} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  attribute: {
    paddingTop: 20,
  },
  attributeCSB: {
    paddingTop: 0,
  },
  base: {
    display: 'flex',
    flexDirection: 'row',
  },
  listItem: {
    borderWidth: 3,
    borderColor: black,
    borderRadius: 4,
    marginVertical: -16,
    paddingVertical: 16,
  },
  textWrapper: {
    paddingLeft: 16,
    flex: 1,
    flexShrink: 1,
    minWidth: 0,
  },
  roleContainer: {
    flexShrink: 1,
    minWidth: 0,
    width: '100%',
  },
  arrowIcon: {
    color: graniteGray,
    fontSize: 24,
    alignSelf: 'center',
  },
  clientFullNameText: {
    color: ravenBlack,
    fontSize: 16,
    paddingBottom: 3,
    lineHeight: 21,
    fontWeight: '600',
    marginRight: 10,
  },
  clientRoleText: {
    color: graniteGray,
    fontSize: 12,
    paddingBottom: 3,
    lineHeight: 18,
    fontWeight: '400',
  },
  peopleToContactAttributeText: {
    color: ravenBlack,
    fontSize: 14,
    paddingBottom: 3,
    lineHeight: 21,
    fontWeight: '400',
  },
  nameContainer: {
    flexDirection: 'row',
  },
  nameContainerCSB: {
    flexDirection: 'row',
    marginTop: 4,
  },
});
